var window_width = $(window).width();
var window_height = $(window).height();
var mapa_ancho_max = 2952;
var mapa_altura_max = 5285;

function mapaCoordenadasXY(anchoPorcent, altoPorcent) {

	var ret;
	// ancho (Y)
	ret = '-' + ((mapa_ancho_max / 100 * anchoPorcent) - ($(window).width() / 2)) + 'px';
	// debugger
	// alto (X)
	ret += ' -' + ((mapa_altura_max / 100 * altoPorcent) - ($(window).height() / 2)) + 'px';

	var str = ret;
	ret = str.replace("--", ""); //hay q rever este algoritmo

	// console.log(ret);
	// debugger
	return ret;
}


$(window).on('resize', function () {
	var win = $(this); //this = window
	if (win.height() >= 820) {
		console.log('win.height() >= 820');
	}
	if (win.width() >= 1280) {
		console.log('win.width() >= 1280');
	}

	// controller.update();
	// alert('resize => h: ' + win.height() + ', w: ' + win.width());
	console.log('resize => h: ' + win.height() + ', w: ' + win.width());
	// initMapSecuence();
});


$(window).on('load', function () {
	console.log('window.load()');
	initMapSecuence();
});

$('#secuence_mapa').css('background-position', mapaCoordenadasXY(50, 50));

function initMapSecuence() {
	$('.loader').show();


	$(function () { // wait for document ready
		var wh = $(window).height();

		var mapa_ancho_max = 2952;
        var mapa_altura_max = 5285;
        var mapa = document.querySelector('#secuence_mapa')
        var maquina = document.querySelector('#secuence_maquina')

		$('html,body')
			.animate({
				scrollTop: $('#secuence_container').height() * 2
			}, 100)
			.animate({
				scrollTop: 0
			}, 100, function () {
				// Animation complete.
				$('.loader').delay(100).fadeOut("slow");
				console.clear();

			});

		// init controller
		window.controller = new ScrollMagic.Controller({
            /*graphic indicators in the screen for debugging purposes*/
            // addIndicators: true, 
            // loglevel: 3
            
		});

		// start secuence

		// build yt video
		var ytvideo = new ScrollMagic.Scene({
			triggerElement: "#ytvideo",
			duration: wh,
			offset: wh / 2,

		}).setPin("#ytvideo")
			.setTween("#ytvideo", {
				// scale: 1.1
			})
			.addTo(controller);


		//  secuence_01
		var secuence_01 = new ScrollMagic.Scene({
			triggerElement: "#secuence_01",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				// backgroundPositionX: '0%',
				// backgroundPositionY: '45%',
				// backgroundPosition: mapaCoordenadasXY(50, 20),
				backgroundPosition: mapaCoordenadasXY(50, 11.78),
				opacity: 0
			})
			.addTo(controller);

		// nav_secuence_01
		var nav_secuence_01 = new ScrollMagic.Scene({
			triggerElement: "#secuence_02",
			duration: wh,
			offset: 0
		})
			.setPin(".nav")
			.setTween(".nav", {
				opacity: 1
			})
			.addTo(controller);


		//  secuence_02
		var secuence_02 = new ScrollMagic.Scene({
			triggerElement: "#secuence_02",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				opacity: 1,
				// backgroundPositionX: '0%',
				// backgroundPositionY: '0%',
				// backgroundSize: '30%'
			})
			.addTo(controller);


		//  secuence_03
		var secuence_03 = new ScrollMagic.Scene({
			triggerElement: "#secuence_03",
			duration: wh,
			offset: 0
		}).setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				backgroundPosition: '79% 40%', // capital
				// backgroundSize: 'auto',
				opacity: 1
			})
			.addTo(controller);


		var secuence_maquina_03 = new TimelineMax();
		secuence_maquina_03 // capital
			.to("#secuence_maquina", 1, { opacity: 0, left: '0%', top: '50%' })
			.to("#secuence_maquina", 1, { opacity: 1, left: '30%', top: '15%' })
			.to("#secuence_maquina", 1, { opacity: 1, left: '60%', top: '20%' });

		var secuence_03 = new ScrollMagic.Scene({
			triggerElement: "#secuence_03",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_maquina")
			.setTween(secuence_maquina_03)
			.addTo(controller);



		//  secuence_04_mapa
		var secuence_04_mapa = new ScrollMagic.Scene({
			triggerElement: "#secuence_04",
			duration: wh,
			offset: 0
		}).setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				// backgroundPosition: '89% 38%',
				backgroundPosition: mapaCoordenadasXY(70.5, 40.2), // capital si
				opacity: 1
			})
			.addTo(controller);



		// cartel_01
		var cartel_01 = new ScrollMagic.Scene({
			triggerElement: "#cartel_01",
			duration: wh,
			offset: 230
		})
			.setPin("#cartel_01")
			.setTween("#cartel_01", {
				scale: 1.1,
				opacity: 1
			})
			.addTo(controller);

		//  secuence_05


		//  secuence_06
		var secuence_06 = new ScrollMagic.Scene({
			triggerElement: "#secuence_06",
			duration: wh,
			offset: 0
		}).setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				// backgroundPosition: '14% 49.6%', // neuquen
				backgroundPosition: mapaCoordenadasXY(24.3, 53.6), // neuquen si
				opacity: 1
			})
			.addTo(controller);


		var secuence_maquina_06 = new TimelineMax();
		secuence_maquina_06
			// left: '50%', top: '10%'
			.to("#secuence_maquina", 1, { left: '57%', top: '49%' }) // neuquen
			.to("#secuence_maquina", 1, { left: '45%', top: '73%' });

		var secuence_06_maquina = new ScrollMagic.Scene({
			triggerElement: "#secuence_06",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_maquina")
			.setTween(secuence_maquina_06)
			.addTo(controller);

		//  secuence_07


		//  secuence_08
		var cartel_02 = new ScrollMagic.Scene({
			triggerElement: "#cartel_02",
			duration: wh,
			offset: 230
		}).setPin("#cartel_02")
			.setTween("#cartel_02", {
				scale: 1.1,
				opacity: 1
			})
			.addTo(controller);

		//  secuence_10
		var secuence_10 = new ScrollMagic.Scene({
			triggerElement: "#secuence_10",
			duration: wh,
			offset: 0
		}).setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				// backgroundPosition: '72% 28%',
				backgroundPosition: mapaCoordenadasXY(64, 33), // rosario si
				opacity: 1
			})
			.addTo(controller);



		var secuence_maquina_10 = new TimelineMax(); // rosario si
		secuence_maquina_10
			.to("#secuence_maquina", 1, { left: '40%', top: '50%' })
			.to("#secuence_maquina", 1, { left: '55%', top: '41%' });

		var secuence_10_maquina = new ScrollMagic.Scene({
			triggerElement: "#secuence_10",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_maquina")
			.setTween(secuence_maquina_10)
			.addTo(controller);

		//  secuence_12
		var cartel_03 = new ScrollMagic.Scene({
			triggerElement: "#cartel_03",
			duration: wh,
			offset: 230
		})
			.setPin("#cartel_03")
			.setTween("#cartel_03", {
				scale: 1.1,
				opacity: 1
			})
			.addTo(controller);






		//  secuence_14
		var secuence_14 = new ScrollMagic.Scene({
			triggerElement: "#secuence_14",
			duration: wh,
			offset: 0
		}).setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				// backgroundPosition: '19% 53%', // rosario transition
				backgroundPosition: mapaCoordenadasXY(25, 50), // rosario transition
				opacity: 1
			})
			.addTo(controller);


		var secuence_maquina_14 = new TimelineMax();
		secuence_maquina_14
			.to("#secuence_maquina", 1, { left: '50%', top: '30%' }) // neuquen
			.to("#secuence_maquina", 1, { left: '47%', top: '66%' });

		var secuence_14 = new ScrollMagic.Scene({
			triggerElement: "#secuence_14",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_maquina")
			.setTween(secuence_maquina_14)
			.addTo(controller);

		//  secuence_15
		var secuence_15 = new ScrollMagic.Scene({
			triggerElement: "#secuence_15",
			duration: wh,
			offset: 0
		}).setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				// backgroundPosition: '19% 53%', // rosario
				opacity: 1
			})
			.addTo(controller);



		//  secuence_16
		var secuence_16 = new ScrollMagic.Scene({
			triggerElement: "#secuence_16",
			duration: wh,
			offset: 0
		}).setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				// backgroundPosition: '19% 53%', // san mart
				// backgroundPosition: mapaCoordenadasXY(20, 60), // san mart
				opacity: 1
			})
			.addTo(controller);


		var cartel_04 = new ScrollMagic.Scene({
			triggerElement: "#cartel_04",
			duration: wh,
			offset: 230
		})
			.setPin("#cartel_04")
			.setTween("#cartel_04", {
				scale: 1.1,
				opacity: 1
			})
			.addTo(controller);


		//  secuence_17
		var secuence_17 = new ScrollMagic.Scene({
			triggerElement: "#secuence_17",
			duration: wh,
			offset: 0
		}).setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				// backgroundPosition: '19% 53%', // rosario
				opacity: 1
			})
			.addTo(controller);

		//  secuence_18_mapa
		var secuence_18_mapa = new ScrollMagic.Scene({
			triggerElement: "#secuence_18",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				// backgroundPosition: '0% 53%', // rosario
				// backgroundPosition: '79% 40%' // capital
				backgroundPosition: mapaCoordenadasXY(72, 39), // capital si
				opacity: 1
			})
			.addTo(controller);

		var secuence_maquina_18 = new TimelineMax();
		secuence_maquina_18 // capital
			.to("#secuence_maquina", 1, { left: '50%', top: '50%' })
			.to("#secuence_maquina", 1, { left: '55%', top: '30%' })
			.to("#secuence_maquina", 1, { left: '54%', top: '30%' });

		var secuence_18 = new ScrollMagic.Scene({
			triggerElement: "#secuence_18",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_maquina")
			.setTween(secuence_maquina_18)
			.addTo(controller);



		// secuence_18_cartel
		var secuence_18_cartel = new ScrollMagic.Scene({
			triggerElement: "#cartel_05",
			duration: wh,
			offset: 230
		}).setPin("#cartel_05")
			.setTween("#cartel_05", {
				scale: 1.1
			})
			.addTo(controller);


		// var secuence_19_mapa = new ScrollMagic.Scene({
		// 	triggerElement: "#secuence_19",
		// 	duration: wh,
		// 	offset: wh / 2
		// }).setPin("#secuence_mapa")
		// 	.setTween("#secuence_mapa", {
		// 		backgroundPosition: '79% 40%' // capital

		// 	})
		// 	.addTo(controller);

		var secuence_20_mapa = new ScrollMagic.Scene({
			triggerElement: "#secuence_20",
			duration: wh,
			offset: wh / 2
		}).setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				// opacity: 0,
				backgroundPosition: '79% 40%' // capital

			})
			.addTo(controller);

		var secuence_maquina_20 = new ScrollMagic.Scene({
			triggerElement: "#secuence_20",
			duration: wh,
			// offset: 0
		})
			.setPin("#secuence_maquina")
			.setTween(secuence_maquina_20)
			.addTo(controller);

		//  secuence_21
		var secuence_21 = new ScrollMagic.Scene({
			triggerElement: "#secuence_21",
			duration: wh,
			offset: 0
		}).setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				// backgroundPosition: '14% 49.6%', // neuquen
				backgroundPosition: mapaCoordenadasXY(24.3, 53.6), // neuquen si
				opacity: 1
			})
			.addTo(controller);


		var secuence_maquina_21 = new TimelineMax();
		secuence_maquina_21
			// left: '50%', top: '10%'
			.to("#secuence_maquina", 1, { left: '57%', top: '49%' }) // neuquen
			.to("#secuence_maquina", 1, { left: '45%', top: '73%' });

		var secuence_21_maquina = new ScrollMagic.Scene({
			triggerElement: "#secuence_21",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_maquina")
			.setTween(secuence_maquina_21)
			.addTo(controller);

		// secuence_22_cartel colonia suiza
		var secuence_22_cartel = new ScrollMagic.Scene({
			triggerElement: "#cartel_06",
			duration: wh,
			offset: 230
		}).setPin("#cartel_06")
			.setTween("#cartel_06", {
				scale: 1.1
			})
			.addTo(controller);

		// comienza chalten
		//  secuence_24 (go to chalten)
		var secuence_24 = new ScrollMagic.Scene({
			triggerElement: "#secuence_24",
			duration: wh,
			offset: 0
		}).setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				// backgroundPosition: '14% 49.6%', // go to chalten
				// backgroundPosition: mapaCoordenadasXY(24.3, 53.6), // go to chalten
				backgroundPosition: mapaCoordenadasXY(20, 76.6), // go to chalten
				opacity: 1
			})
			.addTo(controller);

		// go to chalten
		var secuence_maquina_24 = new TimelineMax();
		secuence_maquina_24
			// left: '50%', top: '10%'
			.to("#secuence_maquina", 1, { left: '57%', top: '49%' }) // neuquen
			.to("#secuence_maquina", 1, { left: '45%', top: '73%' });

		var secuence_24_maquina = new ScrollMagic.Scene({
			triggerElement: "#secuence_24",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_maquina")
			.setTween(secuence_maquina_24)
			.addTo(controller);

		// secuence_25_cartel el chalten
		var secuence_25_cartel = new ScrollMagic.Scene({
			triggerElement: "#cartel_07",
			duration: wh,
			offset: 230
		}).setPin("#cartel_07")
			.setTween("#cartel_07", {
				scale: 1.1
			})
			.addTo(controller);
		// termina chalten

		// Empieza Capital federal	

		var secuence_27_mapa = new ScrollMagic.Scene({
			triggerElement: "#secuence_27",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				backgroundPosition: mapaCoordenadasXY(72, 39), // capital si
				opacity: 1
			})
			.addTo(controller);

		var secuence_maquina_27 = new TimelineMax();
		secuence_maquina_27 // capital
			.to("#secuence_maquina", 1, { left: '50%', top: '50%' })
			.to("#secuence_maquina", 1, { left: '55%', top: '30%' })
			.to("#secuence_maquina", 1, { left: '54%', top: '30%' });

		var secuence_27 = new ScrollMagic.Scene({
			triggerElement: "#secuence_27",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_maquina")
			.setTween(secuence_maquina_27)
			.addTo(controller);

		// secuence_28_cartel
		var secuence_28_cartel = new ScrollMagic.Scene({
			triggerElement: "#cartel_baires",
			duration: wh,
			offset: 230
		}).setPin("#cartel_baires")
			.setTween("#cartel_baires", {
				scale: 1.1
			})
			.addTo(controller);

		// Termina Capital federal	

		// Empieza Ushuaia
		
		


		var secuence_29_mapa = new ScrollMagic.Scene({
			triggerElement: "#secuence_29",
			duration: wh,
			offset: 230
		})
			.setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				backgroundPosition: mapaCoordenadasXY(51, 92),
				opacity: 1
			})
			.addTo(controller);

		var secuence_maquina_29 = new TimelineMax();
		secuence_maquina_29 // ushuaia
			.to("#secuence_maquina", 1, { left: '50%', top: '45%' })
			.to("#secuence_maquina", 1, { left: '40%', top: '55%' })
			.to("#secuence_maquina", 1, { left: '30%', top: '60%' })

		var secuence_29 = new ScrollMagic.Scene({
			triggerElement: "#secuence_29",
			duration: wh,
			offset: 0
		})
		secuence_29.setPin("#secuence_maquina")
		secuence_29.setTween(secuence_maquina_29)
		secuence_29.addTo(controller);

		var secuence_30_cartel = new ScrollMagic.Scene({
			triggerElement: "#cartel_ushuaia",
			duration: wh/2,
			offset: 230
		}).setPin("#cartel_ushuaia")
			.setTween("#cartel_ushuaia", {
				scale: 1.1
			})
			.addTo(controller);
		
		// Termina Ushuaia

		// Empieza Mendoza

			
		var secuence_31_mapa = new ScrollMagic.Scene({
			triggerElement: "#secuence_mendoza",
			duration: wh,
			offset: 230
		})
			.setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				backgroundPosition: mapaCoordenadasXY(42, 33),
				opacity: 1
			})
			.addTo(controller);

		var secuence_maquina_31 = new TimelineMax();
		secuence_maquina_31 
			.to("#secuence_maquina", 1, { left: '30%', top: '60%' })
			.to("#secuence_maquina", 1, { left: '30%', top: '60%' })

		var secuence_31 = new ScrollMagic.Scene({
			triggerElement: "#secuence_mendoza",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_maquina")
			.setTween(secuence_maquina_31)
			.addTo(controller);

		var secuence_32_cartel = new ScrollMagic.Scene({
			triggerElement: "#cartel_mendoza",
			duration: wh,
			offset: 230
		}).setPin("#cartel_mendoza")
			.setTween("#cartel_mendoza", {
				scale: 1.1
			})
			.addTo(controller);


		// Termina Mendoza

		//Empieza Bariloche

		var secuence_33_mapa = new ScrollMagic.Scene({
			triggerElement: "#secuence_bariloche",
			duration: wh,
			offset: 230
		})
			.setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				backgroundPosition: mapaCoordenadasXY(24, 53.6),
				opacity: 1
			})
			.addTo(controller);

		var secuence_maquina_33 = new TimelineMax();
		secuence_maquina_33 
			.to("#secuence_maquina", 1, { left: '57%', top: '49%' })
			.to("#secuence_maquina", 1, { left: '45%', top: '73%' });
	

		var secuence_33 = new ScrollMagic.Scene({
			triggerElement: "#secuence_bariloche",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_maquina")
			.setTween(secuence_maquina_33)
			.addTo(controller);

		var secuence_34_cartel = new ScrollMagic.Scene({
			triggerElement: "#cartel_bariloche",
			duration: wh,
			offset: 230
		}).setPin("#cartel_bariloche")
			.setTween("#cartel_bariloche", {
				scale: 1.1
			})
			.addTo(controller);

		//Termina Bariloche

		//Empieza Esquel
		var secuence_34_mapa = new ScrollMagic.Scene({
			triggerElement: "#secuence_esquel",
			duration: wh,
			
		})
			.setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				backgroundPosition: mapaCoordenadasXY(24, 63.6),
				opacity: 1
			})
			.addTo(controller);

		var secuence_maquina_34 = new TimelineMax();
		secuence_maquina_34
			.to("#secuence_maquina", 1, { left: '55%', top: '40%' });
	

		var secuence_34 = new ScrollMagic.Scene({
			triggerElement: "#secuence_esquel",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_maquina")
			.setTween(secuence_maquina_34)
			.addTo(controller);

		var secuence_35_cartel = new ScrollMagic.Scene({
			triggerElement: "#cartel_esquel",
			duration: wh/2,
			offset: 230
			
		}).setPin("#cartel_esquel")
			.setTween("#cartel_esquel", {
				scale: 1.1
			})
			.addTo(controller);
		//Termina Esquel

		//Empieza SMA
		var secuence_35_mapa = new ScrollMagic.Scene({
			triggerElement: "#secuence_sma",
			duration: wh,
			
		})
			.setPin("#secuence_mapa")
			.setTween("#secuence_mapa", {
				backgroundPosition: mapaCoordenadasXY(25, 55.6),
				opacity: 1
			})
			.addTo(controller);

		var secuence_maquina_34 = new TimelineMax();
		secuence_maquina_34
			.to("#secuence_maquina", 1, { left: '49%', top: '30%' });
	

		var secuence_34 = new ScrollMagic.Scene({
			triggerElement: "#secuence_sma",
			duration: wh,
			offset: 0
		})
			.setPin("#secuence_maquina")
			.setTween(secuence_maquina_34)
			.addTo(controller);

		var secuence_35_cartel = new ScrollMagic.Scene({
			triggerElement: "#cartel_sma",
			duration: wh,
			offset: 100,
		}).setPin("#cartel_sma")
			.setTween("#cartel_sma", {
				scale: 1.1
			})
			.addTo(controller);
		//Termina SMA

		// build go top
		var go_top = new ScrollMagic.Scene({
			triggerElement: "#go_top",
			// duration: wh,
			//offset: -200,

		});
		go_top.setPin("#go_top")
			.setTween("#go_top", {
				scale: 1.1
			})
			.addTo(controller);

		$('#go_to_video').click(function () {
			$('html,body').animate({
				scrollTop: $('#ytvideo').offset().top + wh
			}, 'slow');
			return false;
		});

		$('#go_top').click(function () {
			$('html,body').animate({
				scrollTop: 0
			}, 'slow');
			return false;
		});

		$(window).on('resize', function () {
			controller.update();
			console.log('window resize fn controller.update();');
		});

		// menu mapa
		$('.nav li a').click(function () {
			var href = $(this).attr('href');
			var top = $(href).offset().top;
			$('body,html').animate({
				scrollTop: top
			}, 800);
			return false;
		});
	});
}




// $(function () { // wait for document ready
// 	initMapSecuence();
// });